import { defineMessages } from 'react-intl';

const trns = defineMessages({
  seoText: {
    id: '3P89Sg',
    defaultMessage: 'читати далі'
  },
  seoContainerTitle: {
    id: 'nq+dt0',
    defaultMessage: 'Довідник аптек і список лікарських засобів Likie'
  },
  alphabeticalIndex: {
    id: 'b7U4Jh',
    defaultMessage: 'Абетковий вказівник препаратів '
  },
  showMoreTitle: {
    id: 'vkL/zB',
    defaultMessage: 'Розгорнути'
  },
  showLessTitle: {
    id: 'f/WfD8',
    defaultMessage: 'Згорнути'
  },
  seoTextHome1: {
    id: 'zZpBFH',
    defaultMessage:
      'Likie - сервіс швидкого пошуку ліків в аптеках будь-якого міста України. Дізнавайтеся про наявність ліків в аптеках онлайн!'
  },
  seoTextHome2: {
    id: 'Rz6AOH',
    defaultMessage:
      'Каталог таблеток Likie містить опис медикаментів, інструкції до ліків та правила застосування. Огляд та відгуки на кожен засіб допоможуть визначитися з вибором і купити лікарські препарати за найкращою ціною.'
  },
  seoTextHome3: {
    id: 'CWDD8B',
    defaultMessage:
      'Ви зможете отримати замовлення в найбільш зручній для вас аптеці, обравши її із запропонованого списку в процесі замовлення.'
  },
  seoTextHome4: {
    id: 'do1bRm',
    defaultMessage: 'Переваги довідника цін на ліки Likie:'
  },
  seoTextHome5: {
    id: 'GaIktc',
    defaultMessage:
      '- Довідник містить списки таблеток з рецептурою, дієтичних добавок, медичних виробів, косметичних засобів, продуктів клінічного та дитячого харчування, зареєстрованих та представлених на фармацевтичному ринку України.'
  },
  seoTextHome6: {
    id: 'AryE4s',
    defaultMessage:
      '- Каталог лікарських препаратів постійно оновлюється та вдосконалюється, щодня ми додаємо сотні нових товарів з докладним описом їх складу та чіткими рекомендаціями щодо застосування. Точні фото товарів спрощують пошук і замовлення ліків.'
  },
  seoTextHome7: {
    id: 'I2Tqpn',
    defaultMessage:
      '- Ієрархічна структура сучасної класифікаційної системи АТС (Anatomical Therapeutic Chemical) та групування лікарських препаратів відповідно до INN (International Nonproprietary Names) допомагає проводити пошук ліків за активною речовиною та легко підбирати аналоги.'
  },
  seoTextHome8: {
    id: 'TLdUuc',
    defaultMessage:
      '- Зручна система пошуку та навігації дозволяє швидко та результативно зорієнтуватися у всьому розмаїтті запропонованих медичних товарів.'
  },
  seoTextHome9: {
    id: '56ZlmJ',
    defaultMessage: 'Які товари можна замовити на сайті Likie?'
  },
  seoTextHome10: {
    id: 'BrHCu0',
    defaultMessage:
      '- БАДи та вітаміни, мінеральні добавки, сорбенти й детоксиканти, фітопрепарати'
  },
  seoTextHome11: {
    id: '1G5Tj0',
    defaultMessage: '- Ліки широкого профілю'
  },
  seoTextHome12: {
    id: 'OuyXKD',
    defaultMessage: '- Вакцини'
  },
  seoTextHome13: {
    id: 'Qdj2oL',
    defaultMessage: '- Антибіотики'
  },
  seoTextHome14: {
    id: '3WjeUf',
    defaultMessage:
      '- Лікувальна та декоративна косметика, засоби для гігієни порожнини рота'
  },
  seoTextHome15: {
    id: 'R5NeTJ',
    defaultMessage: '- Товари для мам і дітей'
  },
  seoTextHome16: {
    id: 'ZP+1Yv',
    defaultMessage:
      '- Перев`язувальні та маніпуляційні засоби, бандажі, компресійний трикотаж, підгузки та пелюшки'
  },
  seoTextHome17: {
    id: 'EyWyZ+',
    defaultMessage: '- Товари для сексуального здоров`я'
  },
  seoTextHome18: {
    id: 'REB4pK',
    defaultMessage: '- Контактні лінзи та розчин для них'
  },
  seoTextHome19: {
    id: 'Ei54hn',
    defaultMessage: '- Товари для косметологів'
  },
  seoTextHome20: {
    id: '1PLygT',
    defaultMessage:
      'Likie - це сертифіковані ліки, продуманий сервіс та корисні поради для щоденного зміцнення здоров`я.'
  }
});

export default trns;
